import { Board, ProductionStatus } from "../../../../reducers/uploadedBoard";
import { useBoardFromContext } from "../../../../utils/hooks/commonly-stored/uploaded-board/board";
import useShipmentHistory from "../../../../utils/hooks/commonly-stored/uploaded-board/shipmentHistory";
import LoadingIcon from "../../../common/LoadingIcon";
import {
  FlashPCBTable,
  TableCell,
  TableHeaderCell,
  TableHeaderRow,
  TableRow,
} from "../../../../constants/Styles";
import {
  dateStringToHumanReadableDate,
  datetimeStringToHumanReadableDatetime,
} from "../../../../utils/valueFormatting";
import React from "react";
import { CHECK } from "../../../../constants/Text";
import { UserIdPill } from "../../../common/UserPill";

export default function ShipmentHistory() {
  const board = useBoardFromContext().board as Board;

  const { shipmentHistory } = useShipmentHistory(board.id);

  if (shipmentHistory === null) {
    return <LoadingIcon text={"Loading history..."} centerHorizontally />;
  }

  return (
    <FlashPCBTable>
      <thead>
        <TableHeaderRow>
          <TableHeaderCell>Shipment id</TableHeaderCell>
          <TableHeaderCell>Time</TableHeaderCell>
          <TableHeaderCell>Action</TableHeaderCell>
          <TableHeaderCell>User</TableHeaderCell>
          <TableHeaderCell>Num boards</TableHeaderCell>
          <TableHeaderCell>Ship date</TableHeaderCell>
          <TableHeaderCell>Manufactured</TableHeaderCell>
        </TableHeaderRow>
      </thead>
      <tbody>
        {shipmentHistory.records.map((record, recordIndex) => {
          return (
            <TableRow key={record.datetime_created + recordIndex}>
              <TableCell>{record.shipment_id || "-"}</TableCell>
              <TableCell>
                {datetimeStringToHumanReadableDatetime(record.datetime_created)}
              </TableCell>
              <TableCell>{record.action}</TableCell>
              <TableCell>
                <UserIdPill userId={record.user_id} />
              </TableCell>
              <TableCell>{record.num_boards.toLocaleString()} boards</TableCell>
              <TableCell>
                {record.ship_date
                  ? dateStringToHumanReadableDate(record.ship_date, true)
                  : "-"}
              </TableCell>
              <TableCell>
                {record.production_status == ProductionStatus.MANUFACTURED &&
                  CHECK}
              </TableCell>
            </TableRow>
          );
        })}
      </tbody>
    </FlashPCBTable>
  );
}
